import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import {isEmpty} from "../../../components/Utils/common";

import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import NewUser from "../../users/newUser";
import { FormControl, InputLabel, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Controller } from 'react-hook-form';


function MerchantOfficeDetails({merchant, editmode, setMerchant, type}) {
  const [referenceCompany, setReferenceCompany] = useState("");
  const [masterType, setMasterType] = useState("");
  const [merchantCode, setMerchantCode] = useState("");
  const { register, formState: { errors }, requiredInfo, control } = useFormContext();

  useEffect(() => {
    if(merchant?.merchant?.referenceId) {
      setReferenceCompany(merchant?.merchant?.referenceId);
      setMasterType(merchant?.merchant?.microAtmStatus);
      // setMerchantCode(merchant?.merchant?.merchantCategoryCode.merchantCode);
    }
  }, [merchant]);

  // console.log("ref: ", merchant?.merchant?.referenceId);
  return (
      <Grid mt={3} mb={3} padding={2}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={3}>
            <MDInput
              type="text"
              label="Merchant Id"
              name="mid"
              error={errors?.mid}
              helperText={errors.mid ? errors.mid.message : ''}
              {...register("mid")}
              fullWidth
              disabled={type === "update"}
            />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Registered Business Name" name="companyName"
                     error={errors.companyName}
                     helperText={errors.companyName ? errors.companyName.message : ''}
                     disabled={!editmode}
                     fullWidth
                     {...register("companyName")}
            />
          </Grid>
          <Grid item xs={3}>
            <FormControl fullWidth style={{height: '100%'}}>
              <InputLabel id="demo-simple-select-label">Type of Entity</InputLabel>
              <Controller
                name="typeEstablishment"
                control={control} // make sure to get "control" from useForm()
              
                render={({ field }) => (
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Type of Entity"
                    fullWidth
                    {...field}
                    error={errors.typeEstablishment}
                    helperText={errors.typeEstablishment ? errors.typeEstablishment.message : ''}
                    style={{height: '100%'}}
                    disabled={!editmode}
                  >
                    <MenuItem value="">-Type of Entity-</MenuItem>
                    <MenuItem value="Proprietorship">Proprietorship</MenuItem>
                    <MenuItem value="Partnership" >Partnership</MenuItem>
                    <MenuItem value="Pvt. Ltd. / Public Ltd." >Pvt. Ltd. / Public Ltd.</MenuItem>
                    <MenuItem value="Company" >Company</MenuItem>
                    <MenuItem value="Trust" >Trust</MenuItem>
                    <MenuItem value="LLP" >LLP</MenuItem>
                    <MenuItem value="Club" >Club</MenuItem>
                    <MenuItem value="NGO" >NGO</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Registered Business Address" name="address"
                     {...register("address")}
                     error={errors.address}
                     helperText={errors.address ? errors.address.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Actual Business Address" name="addressRes"
                     {...register("addressRes")}
                     error={errors.addressRes}
                     helperText={errors.addressRes ? errors.addressRes.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Zip Code" name="pinCode"
                     {...register("pinCode")}
                     error={errors.pinCode}
                     helperText={errors.pinCode ? errors.pinCode.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="MCC" name="mccCode"
                     {...register("mccCode")}
                     error={errors.mccCode}
                     helperText={errors.mccCode ? errors.mccCode.message : ''}
                     fullWidth  disabled={!editmode} />

            {/*<FormControl fullWidth style={{height: '100%'}}>*/}
            {/*  <InputLabel id="demo-simple-select-label">Merchant Category Code</InputLabel>*/}
            {/*  <Controller*/}
            {/*    name="mccCode"*/}
            {/*    control={control} // make sure to get "control" from useForm()*/}
            {/*    defaultValue=""*/}
            {/*    render={({ field }) => (*/}
            {/*      <Select*/}
            {/*        labelId="demo-simple-select-label"*/}
            {/*        id="demo-simple-select"*/}
            {/*        label="Merchant Category Code"*/}
            {/*        fullWidth*/}
            {/*        {...field}*/}
            {/*        error={errors.mccCode}*/}
            {/*        helperText={errors.mccCode ? errors.mccCode.message : ''}*/}
            {/*        style={{height: '100%'}}*/}
            {/*        disabled={!editmode}*/}
            {/*      >*/}
            {/*        <MenuItem value=""> -Select Merchant Category Code- </MenuItem>*/}
            {/*        {requiredInfo?.mcclist && requiredInfo.mcclist.map((item, key) => (*/}
            {/*          <MenuItem key={key} value={item?.merchantCode}>{item?.merchantDescription}</MenuItem>*/}
            {/*        ))}*/}
            {/*      </Select>*/}
            {/*    )}*/}
            {/*  />*/}
            {/*</FormControl>*/}

            {/*<MDInput type="text" label="Merchant Category Code" name="merchantCode" value={merchant?.merchant?.merchantCode} fullWidth  readOnly InputLabelProps={{ shrink: true }} />*/}
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="ABN" name="abn"
                     {...register("abn")}
                     error={errors.abn}
                     helperText={errors.abn ? errors.abn.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="ACN" name="acn"
                     {...register("acn")}
                     error={errors.acn}
                     helperText={errors.acn ? errors.acn.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Years in Business" name="establishmentYrs"
                     {...register("establishmentYrs")}
                     error={errors.establishmentYrs}
                     helperText={errors.establishmentYrs ? errors.establishmentYrs.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          {/*<Grid item xs={3}>*/}
          {/*  <MDInput type="text" label="Sales Tax No" name="saleTaxNo"*/}
          {/*           {...register("saleTaxNo")}*/}
          {/*           error={errors.saleTaxNo}*/}
          {/*           helperText={errors.saleTaxNo ? errors.saleTaxNo.message : ''}*/}
          {/*           fullWidth  disabled={!editmode} />*/}
          {/*</Grid>*/}
          <Grid item xs={3}>
            <MDInput type="text" label="Name of the Owner" name="ownerName"
                     {...register("ownerName")}
                     error={errors.ownerName}
                     helperText={errors.ownerName ? errors.ownerName.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Authorized Person of Company" name="authorizedPerson"
                     {...register("authorizedPerson")}
                     error={errors.authorizedPerson}
                     helperText={errors.authorizedPerson ? errors.authorizedPerson.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Mobile Number" name="mobileNo"
                     {...register("mobileNo")}
                     error={errors.mobileNo}
                     helperText={errors.mobileNo ? errors.mobileNo.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Email" name="emailId"
                     {...register("emailId")}
                     error={errors.emailId}
                     helperText={errors.emailId ? errors.emailId.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="FAX" name="faxNo"
                     {...register("faxNo")}
                     error={errors.faxNo}
                     helperText={errors.faxNo ? errors.faxNo.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Office Phone" name="officeNo"
                     {...register("officeNo")}
                     error={errors.officeNo}
                     helperText={errors.officeNo ? errors.officeNo.message : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          {/*<Grid item xs={3}>*/}
          {/*  <MDInput type="text" label="Tin No" name="tinNo"*/}
          {/*           {...register("tinNo")}*/}
          {/*           error={errors.tinNo}*/}
          {/*           helperText={errors.tinNo ? errors.tinNo.message : ''}*/}
          {/*           fullWidth  disabled={!editmode} />*/}
          {/*</Grid>*/}
          <Grid item xs={3}>
            <MDInput type="text" label="Group MID" name="groupMid"
                     {...register("groupMid")}
                     error={errors.groupMid}
                     helperText={errors.groupMid ? errors.groupMid.message : ''}
                     fullWidth disabled={type === "update"} />
          </Grid>
          <Grid item xs={3}>
            <FormControl fullWidth style={{height: '100%'}}>
              <InputLabel id="demo-simple-select-label">Reference Company Name</InputLabel>
              <Controller
                name="referenceId"
                control={control} // make sure to get "control" from useForm()
                defaultValue=""
                render={({ field }) => (
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Reference Company Name"
                    fullWidth
                    {...field}
                    error={errors.referenceId}
                    helperText={errors.referenceId ? errors.referenceId.message : ''}
                    style={{height: '100%'}}
                    disabled={!editmode}
                  >
                    <MenuItem value=""> -Select Reference Company- </MenuItem>
                    {requiredInfo?.referenceCompany && requiredInfo.referenceCompany.map((item, key) => (
                      <MenuItem key={key} value={item?.referenceId}>{item?.referenceCompanyName}</MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <FormControl fullWidth style={{height: '100%'}}>
              <InputLabel id="demo-simple-select-label">Master Type</InputLabel>
              <Controller
                name="microAtmStatus"
                control={control} // make sure to get "control" from useForm()
                defaultValue=""
                render={({ field }) => (
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Master Type"
                    fullWidth
                    {...field}
                    error={!!errors.microAtmStatus}
                    helperText={errors.microAtmStatus ? errors.microAtmStatus.message : ''}
                    style={{height: '100%'}}
                    disabled={!editmode}
                  >
                    <MenuItem value=""> -Select Master Type- </MenuItem>
                    {requiredInfo?.microAtm && requiredInfo.microAtm.map((item, key) => (
                      <MenuItem key={key} value={item?.microAtmStatus}>{item?.description}</MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
            {/*<MDInput type="text" label="Master Type" name="microAtmStatus" value={merchant?.merchant?.microAtmStatus} fullWidth  readOnly InputLabelProps={{ shrink: true }} />*/}
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="Wallet Balance" name="walletBalance"
                     {...register("walletBalance")}
                     error={errors.walletBalance}
                     helperText={errors.walletBalance ? errors.walletBalance : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
            <FormControl fullWidth style={{height: '100%'}}>
              <InputLabel id="demo-simple-select-label">LCR Enable</InputLabel>
              <Controller
                name="lcrenbale"
                control={control} // make sure to get "control" from useForm()
              
                render={({ field }) => (
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="LCR Enable"
                    fullWidth
                    {...field}
                    error={errors.lcrenbale}
                    helperText={errors.lcrenbale ? errors.lcrenbale.message : ''}
                    style={{height: '100%'}}
                    disabled={!editmode}
                  >
                    <MenuItem value="">-</MenuItem>
                    <MenuItem value="enabled">Enabled</MenuItem>
                    <MenuItem value="disabled">Disabled</MenuItem>
                   
                  </Select>
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <MDInput type="text" label="LCR Amount" name="lcramt"
                     {...register("lcramt")}
                     error={errors.lcramt}
                     helperText={errors.lcramt ? errors.lcramt : ''}
                     fullWidth  disabled={!editmode} />
          </Grid>
          <Grid item xs={3}>
         
          </Grid>
          <Grid item xs={3}>
           
          </Grid>
        </Grid>
      </Grid>
  );
}

MerchantOfficeDetails.defaultProps = {
  merchant: false,
  editmode: false,
  setMerchant: false,
  type: 'update',
  errors: {},
  register: false
}

MerchantOfficeDetails.propTypes = {
  merchant: PropTypes.any,
  editmode: PropTypes.bool,
  setMerchant: PropTypes.func,
  type: PropTypes.string,
  errors: PropTypes.object,
  register: PropTypes.any
}

export default MerchantOfficeDetails;
